import { ModulesMap } from '@/config/data/modulesMaps'
import WorksQualityNormsApi from '@/services/apiServiceModules/worksQualityNormsApi'
import DataTransferModule from '@/services/dataTransferModule'

const worksQualityNormsApi = new WorksQualityNormsApi()

export default class WorksQualityNormsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_QUALITY_NORMS, worksQualityNormsApi, {
			useCache: true,
		})
	}
}
